import { storyblokEditable } from '@storyblok/react/rsc'
import { clsx } from 'clsx'
import { type FC } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokRichTextType } from '../../storyblok'
import { useCmsRichTextRender } from '../../useCmsRichTextRender'

import styles from './StoryblokRichText.module.css'

export const StoryblokRichText: FC<
  StoryblokComponentProps<StoryblokRichTextType>
> = ({ blok }) => {
  const { content, maxHeight } = blok

  const cmsRenderRichText = useCmsRichTextRender()

  return (
    <div
      {...storyblokEditable(blok)}
      className={clsx(
        'prose',
        maxHeight && 'overflow-y-auto',
        styles['storyblok-rich-text'],
      )}
      style={{
        maxHeight: maxHeight ? `${maxHeight}px` : undefined,
      }}
    >
      {cmsRenderRichText(content)}
    </div>
  )
}
